import React from 'react';
import {
  FormikRadioInput as Radio,
  DietActivityLevelType,
} from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const ActivityLevel: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">{t('app.goalSettings.activityLevel.headline')}</h2>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_NONE}>
        <strong>{t('app.goalSettings.activityLevel.optionNoActive.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.activityLevel.optionNoActive.description')}</p>
      </Radio>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_LOW}>
        <strong>{t('app.goalSettings.activityLevel.optionLowActive.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.activityLevel.optionLowActive.description')}</p>
      </Radio>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_MEDIUM}>
        <strong>{t('app.goalSettings.activityLevel.optionMediumActive.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.activityLevel.optionMediumActive.description')}</p>
      </Radio>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_HIGH}>
        <strong>{t('app.goalSettings.activityLevel.optionVeryActive.title')}</strong>
        <p className="mb-0">{t('app.goalSettings.activityLevel.optionVeryActive.description')}</p>
      </Radio>
    </>
  );
};

export default ActivityLevel;
